/* Classnames des Gradients, à virer si je change d'avis à leur sujet */

export const makeGradientColor = (colorStart, colorEnd, angle = 45) => {
  return {
    base: `linear-gradient(${angle}deg, ${colorStart}, ${colorEnd})`,
    levels: {
      level1: `linear-gradient(${angle}deg, ${addOpacity(
        colorStart,
        0.9
      )}, ${addOpacity(colorEnd, 0.9)})`,
      level2: `linear-gradient(${angle}deg, ${addOpacity(
        colorStart,
        0.2
      )}, ${addOpacity(colorEnd, 0.2)})`,
      level3: `linear-gradient(${angle}deg, ${addOpacity(
        colorStart,
        0.14
      )}, ${addOpacity(colorEnd, 0.14)})`,
      level4: `linear-gradient(${angle}deg, ${addOpacity(
        colorStart,
        0.12
      )}, ${addOpacity(colorEnd, 0.12)})`,
      level5: `linear-gradient(${angle}deg, ${addOpacity(
        colorStart,
        0.17
      )}, ${addOpacity(colorEnd, 0.17)})`,
      level6: `linear-gradient(${angle}deg, ${addOpacity(
        colorStart,
        0.3
      )}, ${addOpacity(colorEnd, 0.3)})`,
      level7: `linear-gradient(${angle}deg, ${addOpacity(
        colorStart,
        0.2
      )}, ${addOpacity(colorEnd, 0.2)})`,
    },
  };
};

const addOpacity = (color, opacity) => {
  return color.replace("rgb", "rgba").replace(")", `, ${opacity})`);
};

// Predefined gradients
export const gradients = {
  orangered: makeGradientColor("rgb(255, 165, 0)", "rgb(255, 0, 0)"),
  purpleblue: makeGradientColor("rgb(148, 0, 211)", "rgb(0, 0, 255)"),
  blackred: makeGradientColor("rgb(0, 0, 0)", "rgb(255, 0, 0)"),
  greenyellow: makeGradientColor("rgb(0, 128, 0)", "rgb(255, 255, 0)"),
};
/* Classnames des Gradients, à virer si je change d'avis à leur sujet */



// WEBPACK FOOTER //
// ./src/utils/makeGradientColor.js